import React, { Component } from "react"
import styled from "styled-components"
import { inject, observer } from "mobx-react"

import DesktopContainer from "~/components/DesktopContainer"
import Spacer from "~/components/Spacer"
import GreenButton from "~/components/traffic-tickets/steps/GreenButton"
import FAQ from "./FAQ"
import Hand from "~/public/static/images/png/hand.png"

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: ${props => props.theme.colors.background.main};
  background-image: url(${Hand});
  background-repeat: no-repeat;
  background-position: bottom -5px left 10%;
  background-size: 25%;
  ${props => props.theme.media.smallDesktop`
    background-size: 35%;
  `}
  ${props => props.theme.media.mobile`
    background-size: 65%;
  `}
  ${props => props.theme.media.tiny`
    background-size: 75%;
  `}
`

const BottomFade = styled.div`
  background: rgb(247, 249, 251);
  background: linear-gradient(
    0deg,
    rgba(247, 249, 251, 1) 0%,
    rgba(255, 255, 255, 0) 100%
  );
  width: 100%;
  height: 4em;
  position: fixed;
  bottom: 0;
  z-index: 10;
`

const SavingsHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  color: ${props => props.theme.colors.text.menuItem};
  text-align: center;
`

const SavingSmallText = styled.div`
  margin-top: 2em;
  font-family: ${props => props.theme.fonts.avenirNextMedium};
  font-size: 1.125em;
  margin-bottom: 0.5em;
`

const SavingsTitle = styled.div`
  font-family: ${props => props.theme.fonts.avenirNextHeavy};
  font-size: 2.375em;
`

const SavingAmountText = styled.span`
  color: ${props => props.theme.colors.success};
`

const SavingsSubtitle = styled.div`
  margin-top: 2em;
  font-family: ${props => props.theme.fonts.avenirNextMedium};
  font-size: 1.25em;
  max-width: 315px;
  text-align: center;
  color: ${props => props.theme.colors.text.inputPlaceholder};
`

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 140px;
  max-height: 60px;
`

const ButtonRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`

@inject(all => ({
  nextStep: all.store.parkingFlow.flow.nextStep,
  fightSelected: all.store.parkingFlow.results.fightSelected,
  paySelected: all.store.parkingFlow.results.paySelected,
  isUserPreferredFightOrPay: all.store.parkingFlow.flow.isUserPreferredFightOrPay,
  totalFightableSavings: all.store.parkingFlow.results.totalFightableSavings,
  totalPayableSavings: all.store.parkingFlow.results.totalPayableSavings,
  totalSelectedFightableAmount: all.store.parkingFlow.results.totalSelectedFightableAmount,
  totalSelectedPayableAmount: all.store.parkingFlow.results.totalSelectedPayableAmount

}))
@observer
class ParkingSavings extends Component {
  render() {
    const {
      totalFightableSavings,
      totalPayableSavings,
      fightSelected,
      paySelected,
      totalSelectedFightableAmount,
      totalSelectedPayableAmount,
      isUserPreferredFightOrPay,
      nextStep
    } = this.props
    const totalSavings = isUserPreferredFightOrPay ?  totalPayableSavings : totalFightableSavings
    const arraySelected = isUserPreferredFightOrPay ? paySelected : fightSelected
    const totalSelectedAmount = isUserPreferredFightOrPay ? totalSelectedPayableAmount : totalSelectedFightableAmount
    return (
      <PageContainer>
        <DesktopContainer>
          <SavingsHeader>
            <SavingSmallText>If your ticket is dismissed</SavingSmallText>
            <SavingsTitle>
              YOU WILL SAVE{" "}
              <SavingAmountText>{`$${totalSavings}`}</SavingAmountText>
            </SavingsTitle>
            <SavingsSubtitle>
              You have {arraySelected.length} violation
              {arraySelected.length > 1 ? "s" : ""} with fines totalling $
              {totalSelectedAmount}
            </SavingsSubtitle>
          </SavingsHeader>
          <Spacer mobile={76} desktop={76} />
          <ButtonRow>
            <ButtonContainer>
              <GreenButton text="Proceed" onClick={nextStep} />
            </ButtonContainer>
          </ButtonRow>
          <FAQ />
        </DesktopContainer>
        <BottomFade />
      </PageContainer>
    )
  }
}

export default ParkingSavings
